/* eslint-disable import/no-extraneous-dependencies */
import Swan from "@swan-admin/swan-ai-measurements";
import { getLocalStorageData } from "../utils/util";
import { JWTToken } from "../vars";

export const URLType = {
	DEV: "dev",
	STAGING: "staging",
	PROD: "prod",
};

const DEFAULT_URL_TYPE = URLType.PROD;
const INTERNAL_SWAN_PARAMS = {
	urlType: URLType.PROD,
};

const swanInstances = new Map();

const resolveUrlType = (value) => {
	const normalized = value?.toString().toLowerCase();
	if (normalized === URLType.PROD) return URLType.PROD;
	if (normalized === URLType.STAGING) return URLType.STAGING;
	return URLType.PROD;
};

const getLatestStoredToken = () => (typeof window !== "undefined" ? getLocalStorageData(JWTToken) : undefined);

export const getSwanService = (token, params = {}) => {
	const latestToken = token ?? getLatestStoredToken();
	const urlType = resolveUrlType(params?.urlType ?? INTERNAL_SWAN_PARAMS?.urlType) || DEFAULT_URL_TYPE;
	const cacheKey = `${latestToken || ""}:${urlType}`;

	if (!swanInstances.has(cacheKey)) {
		swanInstances.set(cacheKey, new Swan(undefined, urlType, latestToken || undefined));
	}

	return swanInstances.get(cacheKey);
};

export default getSwanService;
